export class MockEventService {
  emit = jasmine.createSpy('emit');
  on = jasmine.createSpy('on');
}
